require('../../modules/es6.function.has-instance');
module.exports = require('../../modules/_wks-ext').f('hasInstance');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/symbol/has-instance.js
// module id = 159
// module chunks = 0